import { Link } from 'react-router-dom';

function SessionOut() {
  return (
    <div  style={{ textAlign: "center", fontSize: "16px" }}>
      <p>Your session has expired.</p> 
      <p>Please <Link to="/signin" style={{ textDecoration: "underline", color: "rgb(34 211 238)" }}>sign in </Link> again.</p>
  </div>
  );
}

export default SessionOut;